import { render, staticRenderFns } from "./CorrectionView.vue?vue&type=template&id=160e5690&scoped=true&"
import script from "./CorrectionView.vue?vue&type=script&lang=js&"
export * from "./CorrectionView.vue?vue&type=script&lang=js&"
import style0 from "./CorrectionView.vue?vue&type=style&index=0&id=160e5690&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e5690",
  null
  
)

export default component.exports